/* -----------------------------
   PRELOAD IMAGES
------------------------------ */

async function preloadImages(urls) {

  await Promise.all(
    urls.map(src => new Promise(resolve => {

      const img = new Image();

      img.onload = resolve;
      img.onerror = resolve;
      img.src = src;

    }))
  );

}
/* ==========================================
   BROWSER ID
========================================== */

function getBrowserId() {

  let id = localStorage.getItem("cat_bodega_browser_id");

  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("cat_bodega_browser_id", id);
  }

  return id;
}

const browserId = getBrowserId();

/* ==========================================
   DAILY PLAY CHECK
========================================== */

async function checkDailyPlay() {

  const { data, error } = await window.supabaseClient
    .from("game_players")
    .select("last_play, has_won")
    .eq("browser_id", browserId)
    .maybeSingle();

  if (error) {

    console.error(error);

    return {
      canPlay: false,
      hasWon: false
    };

  }

  if (!data) {

    return {
      canPlay: true,
      hasWon: false
    };

  }

  const nyFormatter = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  });

  const todayNY = nyFormatter.format(new Date());

  const lastPlayNY = nyFormatter.format(
    new Date(data.last_play)
  );

  return {

    canPlay: todayNY !== lastPlayNY,

    hasWon: data.has_won

  };

}
/* ==========================================
   CAT BODEGA LOTTO GAME
========================================== */

document.addEventListener("DOMContentLoaded", async () => {

const player = await checkDailyPlay();
console.log("Player object:", JSON.stringify(player));

if (!player.canPlay) {

    document.getElementById("lotto-game").innerHTML = `
      <div style="
        background:#FFD400;
        color:#111;
        border-radius:20px;
        padding:48px 32px;
        text-align:center;
        max-width:520px;
        margin:40px auto;
      ">
        <h2 style="margin-bottom:16px;">
          You've Already Played Today!
        </h2>

        <p style="font-size:20px;line-height:1.5;">
          Thanks for stopping by!
          <br><br>
          Come back tomorrow for another chance to win.
        </p>
      </div>
    `;

    return;
  }

  const board = document.getElementById("board-image");
  const tickets = [...document.querySelectorAll(".ticket")];

  const resultPanel = document.getElementById("result-panel");
  const resultTitle = document.getElementById("result-title");
  const resultText = document.getElementById("result-text");
  const claimButton = document.getElementById("claim-button");

/* -----------------------------
   RANDOM BOARD
------------------------------ */

const boards = window.LOTTO_CONFIG.boards;

board.src =
  boards[Math.floor(Math.random() * boards.length)];

/* -----------------------------
   PRIZES
------------------------------ */

const prizes = [

  {
    name: "Treats",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Treats_Only1.png?v=1789754598",
    variant: 46666040541381
  },

  {
    name: "Shirt",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Shirt_Treats.png?v=1788559003",
    variant: 46666040574149
  },
  {
    name: "Shirt",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Shirt_Treats.png?v=1788559003",
    variant: 46666040574149
  },

  {
    name: "Hat 1",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Hat_v1_Treats.png?v=1788559017",
    variant: 46666040606917
  },

  {
    name: "Hat 2",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Hat_v1_Treats.png?v=1788559017",
    variant: 46859961237701
  },

  {
    name: "Pins",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Treats_Only_b2a80453-c2c3-4d80-99ec-30fa434ba5e0.png?v=1788559052",
    variant: 46859962384581
  },

  {
    name: "Stickers",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Stickers_Treats.png?v=1788559080",
    variant: 46859963203781
  },

  {
    name: "Bundle",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Big_Bad_Bodega_Box_032733d9-a9d7-4858-9288-c9af79ae4584.png?v=1790207889",
    variant: 46859964448965
  },

  {
    name: "100 Thieves",
    icon: "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/100_Thieves_Hoodie_Treats.png?v=1788559104",
    variant: 46859967758533
  }

];

/* -----------------------------
   GET AVAILABLE PRIZES
------------------------------ */

async function getAvailablePrizes() {

  const response = await fetch(
    "/products/cat-bodega-prize-redemption.js"
  );

  const product = await response.json();

  return prizes.filter(prize => {

    const variant = product.variants.find(
      v => Number(v.id) === Number(prize.variant)
    );

    return variant && variant.available;

  });

}

/* -----------------------------
   FILLER ICONS
------------------------------ */

const fillers = [

  "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Try_Again1.png?v=1788565637",

  "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Try_Again2.png?v=1788565637",

  "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Try_Again3.png?v=1788565637",

  "https://cdn.shopify.com/s/files/1/0731/6809/3381/files/Try_Again4.png?v=1788565637"

];

/* -----------------------------
   DETERMINE RESULT
------------------------------ */

let isWinner =
  !player.hasWon && (Math.random() < 0.05);

let winningPrize = null;
let icons = [];

// Verify there is prize inventory
if (isWinner) {

  const availablePrizes = await getAvailablePrizes();

  if (availablePrizes.length > 0) {

    winningPrize =
      availablePrizes[
        Math.floor(Math.random() * availablePrizes.length)
      ];

    icons.push(winningPrize.icon);
    icons.push(winningPrize.icon);

    const remainingIcons = [
      ...fillers,
      ...prizes
        .filter(prize => prize.icon !== winningPrize.icon)
        .map(prize => prize.icon)
    ];

    for (let i = remainingIcons.length - 1; i > 0; i--) {

      const j = Math.floor(Math.random() * (i + 1));

      [remainingIcons[i], remainingIcons[j]] =
        [remainingIcons[j], remainingIcons[i]];

    }

    icons.push(...remainingIcons.slice(0, 4));

  } else {

    isWinner = false;

  }

}

// Build losing board
if (!isWinner) {

  const losingPool = [
    ...fillers,
    ...prizes.map(prize => prize.icon)
  ];

  const uniqueLosingPool = [...new Set(losingPool)];

  for (let i = uniqueLosingPool.length - 1; i > 0; i--) {

    const j = Math.floor(Math.random() * (i + 1));

    [uniqueLosingPool[i], uniqueLosingPool[j]] =
      [uniqueLosingPool[j], uniqueLosingPool[i]];

  }

  icons = uniqueLosingPool.slice(0, 6);

}
  /* -----------------------------
     SHUFFLE
  ------------------------------ */

  for (let i = icons.length - 1; i > 0; i--) {

    const j =
      Math.floor(Math.random() * (i + 1));

    [icons[i], icons[j]] =
      [icons[j], icons[i]];

  }
/* -----------------------------
   PLACE PRIZES
------------------------------ */

const prizeImages = [];

tickets.forEach((ticket, index) => {

  const prize = ticket.querySelector(".prize");

  if (!prize) return;

  prizeImages.push(
    new Promise(resolve => {
      prize.onload = resolve;
      prize.src = icons[index];
    })
  );

});

// Wait until the board image has finished loading
if (!board.complete) {

  await new Promise(resolve => {

    board.onload = resolve;

  });

}

// Wait for every prize image
await Promise.all(prizeImages);

// Reveal the board
const boardContainer = document.getElementById("lotto-board");

boardContainer.style.visibility = "visible";
boardContainer.style.opacity = "1";
  /* -----------------------------
     SCRATCH ENGINE
  ------------------------------ */

  let revealedTickets = 0;

  tickets.forEach(ticket => {

    const canvas =
      ticket.querySelector(".scratch-layer");

    if (!canvas) return;

    const ctx =
      canvas.getContext("2d");

canvas.width = canvas.offsetWidth;
canvas.height = canvas.offsetHeight;
    /* -----------------------------
       SILVER COATING
    ------------------------------ */

    ctx.fillStyle = "#BDBDBD";

    ctx.fillRect(
      0,
      0,
      canvas.width,
      canvas.height
    );

    /* -----------------------------
       METALLIC SPECKLE
    ------------------------------ */

    for (let i = 0; i < 700; i++) {

      ctx.fillStyle =
        Math.random() > 0.5
          ? "#D9D9D9"
          : "#9E9E9E";

      ctx.fillRect(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        2,
        2
      );

    }

    let scratching = false;
    let scratchScore = 0;
    let revealed = false;
        /* -----------------------------
       SCRATCH FUNCTION
    ------------------------------ */

    function scratch(x, y) {

      ctx.globalCompositeOperation =
        "destination-out";

      ctx.beginPath();

      ctx.arc(
        x,
        y,
        18,
        0,
        Math.PI * 2
      );

      ctx.fill();

      scratchScore++;

      if (
        scratchScore > 35 &&
        !revealed
      ) {

        revealed = true;

        revealedTickets++;

        canvas.style.transition =
          "opacity .25s ease";

        canvas.style.opacity = "0";

        canvas.style.pointerEvents =
          "none";

        if (revealedTickets === 6) {

          finishGame();

        }

      }

    }

    /* -----------------------------
       MOUSE SCRATCHING
    ------------------------------ */

   canvas.addEventListener(
  "mousedown",
  e => {

    e.preventDefault();
    scratching = true;

  }
);

    window.addEventListener(
      "mouseup",
      () => {

        scratching = false;

      }
    );

    canvas.addEventListener(
      "mousemove",
      e => {

        if (!scratching) return;

        const rect =
          canvas.getBoundingClientRect();

        scratch(
          e.clientX - rect.left,
          e.clientY - rect.top
        );

      }
    );

    /* -----------------------------
       TOUCH SCRATCHING
    ------------------------------ */

    canvas.addEventListener(
      "touchstart",
      () => {

        scratching = true;

      }
    );

    window.addEventListener(
      "touchend",
      () => {

        scratching = false;

      }
    );

    canvas.addEventListener(
      "touchmove",
      e => {

        if (!scratching) return;

        e.preventDefault();

        const touch =
          e.touches[0];

        const rect =
          canvas.getBoundingClientRect();

        scratch(
          touch.clientX - rect.left,
          touch.clientY - rect.top
        );

      },
      {
        passive: false
      }
    );

  });

  /* -----------------------------
     FINISH GAME
  ------------------------------ */
/* -----------------------------
   RECORD PLAY
------------------------------ */

async function recordPlay() {

  const { data: existing, error } = await window.supabaseClient
    .from("game_players")
    .select("id, has_won, winning_prize")
    .eq("browser_id", browserId)
    .maybeSingle();

  if (error) {
    console.error(error);
    return;
  }

  const payload = {
    browser_id: browserId,
    last_play: new Date().toISOString(),
    has_won: isWinner || (existing?.has_won ?? false),
    winning_prize: isWinner
      ? winningPrize.name
      : (existing?.winning_prize ?? null)
  };

  console.log("Recording play:", payload);
  console.log("Existing player:", existing);

  if (existing) {

    const { error: updateError } = await window.supabaseClient
      .from("game_players")
      .update(payload)
      .eq("browser_id", browserId);

    console.log("Update error:", updateError);

  } else {

    const { error: insertError } = await window.supabaseClient
      .from("game_players")
      .insert(payload);

    console.log("Insert error:", insertError);

  }

}
/* -----------------------------
   FINISH GAME
------------------------------ */

async function finishGame() {

  await recordPlay();

  resultPanel.classList.remove("hidden");

  if (isWinner) {

    resultTitle.textContent = "🎉 YOU WON!";

    resultText.innerHTML = `
      <div style="font-size:34px;font-weight:700;margin-bottom:18px;">
        ${winningPrize.name}
      </div>

      <div style="font-size:18px;line-height:1.5;">
        Your prize is ready! Click below to claim it.
      </div>
    `;

    claimButton.textContent = "Claim My Prize";

    claimButton.style.display = "inline-flex";

    claimButton.onclick = () => {

      window.location.href =
        "/cart/" +
        winningPrize.variant +
        ":1";

    };

  } else {

    resultTitle.textContent = "Almost!";

    resultText.innerHTML = `
      <div style="font-size:22px;line-height:1.5;">
        No matching prizes this time.<br><br>
        Come back tomorrow for another chance to win!
      </div>
    `;

    claimButton.style.display = "none";

  }

}
    /* -----------------------------
     END OF GAME
  ------------------------------ */

});
